import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '../services/config/config.service';
import { isRtlLang } from 'src/functions/rtl.function';
import { toArabicIndicDigits } from 'src/functions/arabic-numerals.function';


@Pipe({
  name: 'currencyFormatter',
  pure: false,
})
export class CurrencyFormatterPipe implements PipeTransform {

  constructor(private configs: ConfigService, private translate: TranslateService) {

  }

  transform(value: any, with_code: boolean = true): string {
    const currencyParam = this.configs.currencyData;
    const isArabic = isRtlLang(this.translate.currentLang);
    let locale = isArabic ? "ar" : "en", currency = this.configs.currency, currencyCode = this.configs.currency || currencyParam.strCode,
        digitsInfo = '1.' + currencyParam.intFractionsCount + "-" + currencyParam.intFractionsCount;
    let amount = formatCurrency(Number.parseFloat(value.toString()), locale, currency, currencyCode, digitsInfo).replace(/[^0-9\.,-]+/g, "");
    if (isArabic) {
      amount = toArabicIndicDigits(amount);
    }

    if (with_code && currencyParam.strSymbol)
      return currencyParam.strSymbol + amount;

    if(!currencyParam.bCodeAppendedEnd)
     return (with_code ? currencyParam.strCode.concat(currencyParam.bAddCodeValueSeparator ? currencyParam.strCodeValueSeparator : ' '): "") + amount;
    return amount + (with_code ? (currencyParam.bAddCodeValueSeparator ? currencyParam.strCodeValueSeparator : ' ').concat(currencyParam.strCode) : "");
  }

}
